module.exports = __webpack_public_path__ + "img/a20cd6a.jpg";